import { computed } from 'vue';
import { isProduction } from '../utils/env';
import type { PluginOptions } from './type';
import { useSettingsStore, useUserStore } from '../stores';

/** sentry 配置 */
const sentryConfig = computed(() => {
  const settingsStore = useSettingsStore();
  return settingsStore.settings.sentryConfig;
});

/** 是否开启sentry上报 */
const isOpenSentry = computed(() => {
  return !!sentryConfig.value?.dsn;
});

const options: PluginOptions = {
  async onVuePluginRegister({ app, router }) {
    if (!isOpenSentry.value) {
      return;
    }

    const Sentry = await import('@sentry/vue');

    (window as any).saSentry = Sentry;

    const { dsn, initData = {} } = sentryConfig.value;

    Sentry.init({
      environment: isProduction ? 'production' : 'development',
      app,
      dsn,
      integrations: [Sentry.browserTracingIntegration({ router })],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ...initData,
    });
  },

  async onUserDataUpdate({ operatorNo }) {
    if (!isOpenSentry.value) {
      return;
    }
    const { profileData } = sentryConfig.value;
    const userStore = useUserStore();
    let config = {};
    if (typeof profileData === 'function') {
      config = await profileData(userStore.originUserInfo);
    } else {
      config = profileData || {};
    }

    const sentry = (window as any).saSentry;
    sentry.setUser({ id: operatorNo, ...config });
  },
};

export default options;
